'use strict';


import { BaseElement } from '../../interfaces/BaseElement';
import { DreamsPreloader } from '../preloader/DreamsPreloader';

export class Scheduler {
	static loaded = false;
	
	constructor (guid) {
		this.guid = guid;
		
		if (!Scheduler.loaded) {
			this.#addScript().then(() => {
				this.meeting = new BmbyScheduler.MeetingScheduler({
					guid: this.guid,
					openBtn: false
				});
			})
		} else {
			this.meeting = new BmbyScheduler.MeetingScheduler({
				guid: this.guid,
				openBtn: false
			});
		}
	}
	
	bind(btn) {
		this.btn = btn;
		this.btn.addEventListener('click',this.#btnHandler.bind(this));
	}
	
	#btnHandler() {
		if (!Scheduler.loaded) {
			const preloader = new DreamsPreloader(document.body);
			const awaitScripts = setInterval(() => {
				if (Scheduler.loaded) {
					clearInterval(awaitScripts);
					preloader.remove();
					this.meeting.show();
				}
			},100);
		} else {
			this.meeting.show();
		}
	}
	
	#addScript() {
		return new Promise(resolve => {
			new BaseElement('script')
				.addAttribute('src','https://bmbyscheduler.azurewebsites.net/bmby-scheduler.js')
				.addAttribute('id','bmbySchedulerScript')
				.addAttribute('defer', true)
				.event('load',() => {
					Scheduler.loaded = true;
					resolve();
				})
				.appendTo(document.head);
			
			new BaseElement('link')
				.addAttribute('href','https://bmbyscheduler.azurewebsites.net/bmby-scheduler.css')
				.addAttribute('id','bmbySchedulerStyles')
				.addAttribute('rel','stylesheet')
				.appendTo(document.head);
		})
	}
	
}
